<template>
  <form v-loading="loading" :class="[$style.loginWrap]" class="login-wrap">
    <div class="left-wrap">
      <h1 :class="[$style.tit]" v-html="$t('login_msg_1')"></h1>
      <p v-html="$t('login_msg_2')"></p>
      <span class="tip">TIP</span>
      <span class="bold">{{ $t('login_msg_3') }}</span>
      <img class="device-img" src="@assets/img/device.png" alt="기기 이미지" />
    </div>
    <div class="right-wrap">
      <LocaleSelect
        style="position:absolute;top:30px; right:30px; z-index:1;"
      ></LocaleSelect>

      <div class="login-logo">
        <img src="@assets/img/cocobank-logo.png" alt="로고" />
      </div>
      <EmailVerificationLogin></EmailVerificationLogin>
    </div>
  </form>
</template>
<script>
import LocaleSelect from '@components/LocaleSelect'
import EmailVerificationLogin from '@/src/components/email-verification-login.vue'
export default {
  components: { LocaleSelect, EmailVerificationLogin },
}
</script>

<style lang="scss" module>
@import '@design';

.loginWrap {
  box-sizing: border-box;
  max-width: 1200px;
  padding: 5%;
  margin: 0 auto;
  margin-top: 80px;
  font-weight: 500;
  text-align: left;
  background: #fff;
}

.tit {
  font-size: 30px;
  font-weight: 500;
  line-height: 1.2;
  color: #333;
  text-align: left;
  letter-spacing: -0.09em;
  word-break: keep-all;
}
</style>
<style scoped>
.login-wrap {
  overflow: hidden;
}
.login-wrap span {
  font-weight: normal;
  color: #999;
}
.login-wrap .tip {
  padding: 2px 10px;
  margin-right: 5px;
  font-size: 12px;
  font-style: italic;
  font-weight: bold;
  color: white;
  background-color: #0068c1;
  border-radius: 20px;
}
.login-wrap .bold {
  font-size: 14px;
  color: #0068c1;
}
.left-wrap {
  box-sizing: border-box;
  float: left;
  width: 50%;
  padding: 4%;
}
.left-wrap p {
  padding-bottom: 20px;
  font-size: 14px;
  line-height: 22px;
  color: #999;
}
.login-wrap .device-img {
  width: 100%;
  padding-top: 50px;
}
.login-wrap .login-logo {
  box-sizing: border-box;
  width: 100%;
  padding: 30px 80px;
  text-align: center;
}
.login-wrap .login-logo img {
  width: 100%;
}
.right-wrap {
  position: relative;
  box-sizing: border-box;
  float: right;
  width: 50%;
  padding: 60px 30px;
  border: 1px solid #e5e5e5;
  border-radius: 5px;
  box-shadow: 10px 10px 10px #eee;
}
.right-wrap .title-img {
  top: 50px;
}

@media (max-width: 767px) {
  .left-wrap,
  .right-wrap {
    float: none;
    width: 100%;
  }
  .login-wrap {
    margin: 0;
  }
  .login-wrap .device-img {
    width: 100%;
    padding: 40px 0;
    text-align: center;
  }
  .login-wrap .login-logo {
    padding: 20px 40px;
  }
  .device-img {
    display: none;
  }
}
</style>
